export default __webpack_public_path__ + "static/media/CNM.9ef4f64b.webp";